var map = {
	"./andorra.png": "1ee5",
	"./argentina.png": "2f56",
	"./armenia.png": "a0be",
	"./austria.png": "f3ab",
	"./bahamas.png": "130d",
	"./bahrain.png": "e079",
	"./belgium.png": "cdc5",
	"./bolivia.png": "6c42",
	"./bosnia.png": "ec9c",
	"./brazil.png": "2ca5",
	"./bulgaria.png": "0f06",
	"./cameroon.png": "a194",
	"./canada.png": "40a5",
	"./cape-verde.png": "a5f2",
	"./chad.png": "5182",
	"./chile.png": "1764",
	"./colombia.png": "624b",
	"./congo.png": "ca68",
	"./cote-d-ivoire.png": "82c7",
	"./croatia.png": "7748",
	"./cuba.png": "d64c",
	"./czech-republic.png": "0116",
	"./democratic-republic-of-the-congo.png": "48a6",
	"./denmark.png": "18d0",
	"./dominica.png": "ecf2",
	"./dominican-republic.png": "e665",
	"./egypt.png": "5b3d",
	"./equatorial-guinea.png": "dead",
	"./estonia.png": "4769",
	"./france.png": "4d54",
	"./gambia.png": "2a81",
	"./georgia.png": "d43a",
	"./germany.png": "eef6",
	"./ghana.png": "dd74",
	"./greece.png": "4eda",
	"./guinea-bissau.png": "0915",
	"./guinea.png": "cd2a",
	"./haiti.png": "fc04",
	"./hungary.png": "5e83",
	"./iceland.png": "e253",
	"./iran.png": "93ca",
	"./ireland.png": "a3d2",
	"./israel.png": "4657",
	"./italy.png": "8d41",
	"./jamaica.png": "e5b8",
	"./kenya.png": "39e9",
	"./kosovo.png": "5cf4",
	"./latvia.png": "7c1d",
	"./liberia.png": "1389",
	"./lithuania.png": "96bf",
	"./macedonia.png": "6f87",
	"./mali.png": "e213",
	"./montenegro.png": "11bd",
	"./morocco.png": "eac2",
	"./netherlands.png": "4c2d",
	"./nigeria.png": "ae78",
	"./norway.png": "e012",
	"./poland.png": "23a8",
	"./portugal.png": "e3cf",
	"./russia.png": "86e2",
	"./rwanda.png": "ffcd",
	"./saint-kitts-and-nevis.png": "0595",
	"./senegal.png": "3dd0",
	"./serbia.png": "8bd8",
	"./sierra-leone.png": "7f9e",
	"./slovakia.png": "9f34",
	"./slovenia.png": "5e54",
	"./spain.png": "f3ab4",
	"./sweden.png": "38bb",
	"./tunisia.png": "9676",
	"./turkey.png": "0f47",
	"./ukraine.png": "ed7f",
	"./united-kingdom.png": "1468",
	"./united-states.png": "a657",
	"./venezuela.png": "eb9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "757f";